"use client";

import { Mail, Phone, Headphones } from "lucide-react";
import { useEffect, useRef } from "react";

export default function TopBar() {
  const atTopRef = useRef(true);

  useEffect(() => {
    const THRESHOLD = 6;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      const nextAtTop = y <= THRESHOLD;

      if (nextAtTop !== atTopRef.current) {
        atTopRef.current = nextAtTop;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={[
        // ✅ Dein ursprüngliches Styling (hier entstehen die Abstände/Height)
        "topbar",
      ].join(" ")}
    >
      <a href="tel:+49 (0) 6196 - 950 591 0" className="topbar-link">
        <Phone className="inline me-2" />
        <strong>Telefon:</strong> +49 6196 95059 10
      </a>

      <a href="mailto:info@sdigroup.de" className="topbar-link">
        <Mail className="inline me-1" />
        <strong>E-Mail:</strong> info<span>&#64;</span>sdigroup.de
      </a>

      <a href="/support" className="topbar-link">
        <Headphones className="inline me-1" />
        <span>Support</span>
      </a>
    </div>
  );
}
